import React, { Component } from 'react'
import ReactTable from 'react-table'
import matchSorter from "match-sorter";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-table/react-table.css'
import './ComplainTable.css'
import Axios from 'axios'
import Login from '../../components/Login/Login'

class ComplainTable extends Component {
    constructor() {
        super()
        this.state = {
            authenticated: localStorage.getItem('token'),
            name: localStorage.getItem('name'),
            config: {
                headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')}
            },
            complains: []
        }
    }

    componentWillMount() {
        if(localStorage.getItem("token"))
            Axios.get('/api/complains', this.state.config).then(res => {
                this.setState({complains: res.data})
            }).catch(error => {
                if(error.response.status === 401){
                    localStorage.clear()
                    window.location.reload()
                }
            })        
    }

    render() {
        let content = !this.state.authenticated?
            <Login/> :
            <div className="complainTable">
                <Login/>
                <header className="Form-header">
                    <h3 className="Form-title">Seguimiento de Quejas y/o Sugerencias</h3>
                </header>
                <ReactTable
                    previousText="Anterior"
                    nextText="Siguiente"
                    data={this.state.complains}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value
                    }
                    /*getTrProps={(state, rowInfo, column, instance) => ({
                        onClick: e => {
                            console.log(rowInfo.row._original._id)
                            window.open(`${document.URL}/${rowInfo.row._original._id}`, '_blank');
                        }
                      })}*/
                    columns={[
                        {
                            Header: "Folio",
                            accessor: "folio",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["folio"] }),
                            filterAll: true
                        },
                        {
                            Header: "Fecha",
                            id: "date",
                            accessor: row => new Date(row.date).toDateString().slice(3, 15),
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["date"] }),
                            filterAll: true
                        },
                        {
                            Header: "Proyecto",
                            accessor: "project",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["project"] }),
                            filterAll: true
                        },
                        {
                            Header: "Nombre",
                            accessor: "name",
                            id: "name",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["name"] }),
                            filterAll: true
                        },
                        {
                            Header: "Área",
                            accessor: "stageId.areaId.name",
                            id: "area",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["area"] }),
                            filterAll: true
                        },
                        {
                            Header: "Etapa",
                            accessor: "stageId.name",
                            id: "etapa",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["etapa"] }),
                            filterAll: true
                        },
                        {
                            Header: "Motivo",
                            accessor: "reasonId.name",
                            id: "motivo",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["motivo"] }),
                            filterAll: true
                        },
                        {
                            Header: "Responsable",
                            accessor: "userId.name",
                            id: "responsable",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["responsable"] }),
                            filterAll: true
                        },
                        {
                            Header: "Estatus",
                            accessor: "status",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["status"] }),
                            filterAll: true
                        },
                        {
                            Header: "Cierre",
                            id: "fecCierre",
                            accessor: row => (row.closeDate !== undefined) ? (
                                new Date(row.closeDate).toDateString().slice(3, 15)
                            ): ("")
                        },
                        {
                            Header: "",
                            id: "link",
                            accessor: row => (row.customer === "Sí") ? (
                                <a href={"https://seguimiento-del-cliente.firebaseapp.com/seguimiento.html?p="+row.project+"?n="+row.location}
                                  target="_blank">Seguimiento</a>
                            ): (<a href={"/Queja/#"+row._id}
                                  target="_blank">Ver Queja</a>)
                        }
                    ]}
                    defaultPageSize={15}
                    className="-striped -highlight"
                />
                <a href="https://peaceful-sierra-78192.herokuapp.com" class="btn btn-primary btnNew">Nueva queja</a>
            </div>
        return content
    }
}

export default ComplainTable


// WEBPACK FOOTER //
// ./src/views/ComplainTable/ComplainTable.js